<template>
    <div
        v-if="newsletter && newsletter.show"
        class="tw-@container tw-max-w-[1024px] tw-mx-auto">
        <div class="tw-flex tw-flex-col tw-rounded-3xl tw-border-2 tw-border-blue tw-p-4 @3xl:tw-flex-row @3xl:tw-items-center  @3xl:tw-gap-4 xl:tw-p-6">
            <img
                alt="Newsletter"
                class="tw-mb-3 tw-size-12 tw-object-contain tw-object-center xl:tw-size-16 @3xl:tw-mb-0"
                :src="useMedia(newsletter.smallIcon).medium" />
            <div>
                <h3
                    class="tw-mb-1 tw-text-base tw-font-bold xl:tw-text-lg"
                    v-html="newsletter.smallTitle"></h3>
                <p
                    class="tw-mb-4 tw-text-sm @3xl:tw-mb-0 xl:tw-text-base"
                    v-html="newsletter.smallText"></p>
            </div>
            <v-btn
                class="tw-w-fit tw-text-sm xl:tw-h-11 xl:tw-text-base @3xl:tw-ms-auto"
                color="primary"
                flat
                rounded="pill">
                <span
                    class="tw-text-xs tw-font-light xl:tw-text-base"
                    v-html="newsletter.smallButtonText"></span>
            </v-btn>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { useAppStore } from '@/store/app';
    import { useMedia } from '@/composables/useMedia';

    const appStore = useAppStore();

    const newsletter = computed(() => {
        return appStore.getNewsletter;
    });
</script>

<style scoped lang="scss"></style>

<style lang="scss"></style>
